export default __webpack_public_path__ + "static/media/footer-image.a98c4689.png";